export const SAVE_SERVICE = 'SAVE_SERVICE';
export const SAVE_SERVICE_SUCCESS = 'SAVE_SERVICE_SUCCESS';
export const SAVE_SERVICE_FAILURE = 'SAVE_SERVICE_FAILURE';
export const ADD_SERVICE_TO_THE_LIST = 'ADD_SERVICE_TO_THE_LIST';
export const UPDATE_SERVICE_IN_THE_LIST = 'UPDATE_SERVICE_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/ServiceForm/actionTypes.js